<div>
    @if (mappedFieldData()) {
        <cipo-grid-form
            [form]="form()"
            [(fieldsData)]="mappedFieldData"
            [fieldIds]="keysOrdered()"
            (onBlur)="checkFormulaField($event)"
            data-testid="transition-dialog-grid-form" />
    } @else if (!fields()) {
        <div>
            <ngx-skeleton-loader
                data-testid="transition-dialog-grid-form-skeleton"
                [theme]="{ width: '100%', height: '12px', margin: '8px 0' }"
                count="5"></ngx-skeleton-loader>
        </div>
    }
</div>
